import { EncryptedStorage } from './EncryptedStorage';
import { STORAGE_KEYS } from '../../shared/constants';
import { SupplierNetwork } from '../../domain/entities';

export class SupplierNetworkStorage {
    static async save(supplierNetwork: SupplierNetwork): Promise<void> {
        await Promise.all([
            EncryptedStorage.setItem(STORAGE_KEYS.SUPPLIER_NETWORK_ID, supplierNetwork.id.toString()),
            EncryptedStorage.setItem(STORAGE_KEYS.SUPPLIER_NETWORK_NAME, supplierNetwork.name),
            EncryptedStorage.setItem(STORAGE_KEYS.SUPPLIER_NETWORK_TOKEN, supplierNetwork.token),
        ]);
    }

    static async load(): Promise<SupplierNetwork | null> {
        try {
            const [id, name, token] = await Promise.all([
                EncryptedStorage.getItem(STORAGE_KEYS.SUPPLIER_NETWORK_ID),
                EncryptedStorage.getItem(STORAGE_KEYS.SUPPLIER_NETWORK_NAME),
                EncryptedStorage.getItem(STORAGE_KEYS.SUPPLIER_NETWORK_TOKEN),
            ]);

            if (!id || !name || !token) return null;

            return new SupplierNetwork(
                parseInt(id, 10),
                name,
                '',
                token
            );
        } catch (error) {
            console.error('Error loading supplier network:', error);
            return null;
        }
    }

    static async clear(): Promise<void> {
        await Promise.all([
            EncryptedStorage.removeItem(STORAGE_KEYS.SUPPLIER_NETWORK_ID),
            EncryptedStorage.removeItem(STORAGE_KEYS.SUPPLIER_NETWORK_NAME),
            EncryptedStorage.removeItem(STORAGE_KEYS.SUPPLIER_NETWORK_TOKEN),
        ]);
    }
}

